<template>
  <div
    class="h-screen max-w-2xl flex flex-col items-center justify-center text-center space-y-10 mx-auto px-5"
  >
    <nuxt-link to="/">
      <nuxt-img
        src="images/logo.svg"
        alt="logo"
        class="w-[134px] h-[37px] lg:w-[181px] lg:h-[50px]"
      />
    </nuxt-link>
    <h1 class="text-xl">OPS, qualcosa è andato storto..</h1>

    <h3 class="text-xl">
      Ci dispiace ma non abbiamo trovato quello che stavi cercando. Puoi
      continuare a navigare il nostro sito cliccando il bottone qui sotto.
    </h3>

    <nuxt-link
      to="/"
      class="mt-6 px-10 py-4 bg-cerise-red-600 text-xl text-white rounded-sm font-semibold"
    >
      VAI ALLA HOME PAGE
    </nuxt-link>
  </div>
</template>

<script setup>
const props = defineProps({
  error: Object,
});
onMounted(() => {
  console.log(props.error)
})
</script>
